<template>
  <section ref="pc_common" :class="[
      'page-common', 
      customClassProp, 
      `detect_deviece_${deviceType}`, 
      `state_${deviceType}`,
      `theme-${domainConfig?.designType || 1}`,
    ]">
    <AppHeader :class="[
      `app_device_detect_is_${deviceType}`, 
      `theme-${domainConfig?.designType || 1}`
    ]" :headerTheme="headerTheme" />
    <slot />
    <!-- <FootBar /> -->

    <AppFooter />
  </section>
</template>

<script>
import { mapGetters } from 'vuex';
import AppFooter from '@/components/AppFooter'
import AppHeader from '@/components/AppHeader.vue'
export default {
  components: {
    AppHeader,
    AppFooter
  },
  props: {
    // 使用不同的prop名称避免与保留字冲突
    classs: {
      type: [String, Array, Object],
      default: ''
    },
    headerTheme: {
      type: String,
      default: 'light' // 默认为light主题
    },
    titlePrefix: {
      type: String,
      default: '' // 每个页面可以传入不同的标题前缀
    },
    metaDescription: {
      type: String,
      default: '' // 每个页面可以传入不同的描述
    }
  },
  computed: {
    ...mapGetters({
      deviceType: 'deviceType',
      domainConfig: 'domainConfig',
    }),
    customClassProp () {
      return this.classs
    },
    pageTitle () {
      const metaTitle = this.domainConfig?.['meta']?.title || 'Default Title';
      // meta.title 通常以 " | xxx" 形式配置，直接拼接前缀即可
      if (metaTitle.startsWith(' | ')) {
        return `${this.titlePrefix}${metaTitle}`;
      }
      return `${this.titlePrefix} | ${metaTitle}`;
    },
    pageDescription () {
      return this.metaDescription || this.domainConfig?.['meta']?.des || 'Default des';
    }
  },
  metaInfo () {
    return {
      title: this.pageTitle,
      meta: [
        {
          name: 'description',
          content: this.pageDescription,
        },
        {
          property: 'og:title',
          content: this.pageTitle,
        },
        {
          property: 'og:description',
          content: this.pageDescription,
        },
      ],
    }
  },
};
</script>